// extracted by mini-css-extract-plugin
export default {"container":"Billing_container__tyrii","inquires":"Billing_inquires__YbH1q"};